import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button";
import { usePlans } from "@/hooks/use-plans";
import { usePromoCode } from "@/hooks/use-promo-code";
import { formatDiscount } from "@/lib/utils";

interface PurchaseButtonProps {
  className?: string;
  wrapperClassName?: string;
  onPurchase: (planId: string) => void;
}

export function PurchaseButton({ className = '', wrapperClassName = '', onPurchase }: PurchaseButtonProps) {
  const { t, i18n } = useTranslation('common');
  const { referralCode } = usePromoCode();
  const { plans, isLoading } = usePlans();
  const annualPlan = plans.find(plan => plan.id === 'annual');

  const trialPeriodDays = annualPlan?.pricing.trialPeriodDays;

  return (
    <div className={`pt-4 pb-4 px-8 md:px-0 max-w-sm mx-auto ${wrapperClassName}`}>
      <Button
        className={`w-full bg-yellow-300 text-slate-800 hover:bg-yellow-400 border-b-4 border-yellow-500 text-base py-6 rounded-lg mt-auto ${className}`}
        onClick={() => {
          onPurchase('annual');
        }}
      >
        {trialPeriodDays
          ? t('purchase.cta.startTrial', { days: trialPeriodDays })
          : t('purchase.cta.subscribe')}
      </Button>

      {referralCode && (annualPlan?.pricing as any)?.referralSavings != null && (annualPlan?.pricing as any).referralSavings > 0 && !isLoading && (
        <p
          className="text-sm mb-2 mt-2 px-4 text-center"
          dangerouslySetInnerHTML={{
            __html: // @ts-ignore
              t('common.scrollToPlansHint', {
                code: referralCode,
                currency: annualPlan?.pricing.currency,
                amount: Number((annualPlan as any).pricing.referralSavings).toLocaleString(),
                discount: formatDiscount(annualPlan?.pricing.discount?.percentage || 0, i18n.language)
              })
          }}
        />
      )}
    </div>
  );
}
